import React, { FC } from 'react';
import styles from './QrCode.module.scss';

export const QrCode: FC = () => (
    <div className={styles.container}>
        <span className={styles.text}>
            Акции, новости, обновления в Telegram-канале
        </span>
        <img src="/assets/qr/telegram.svg" alt="telegram" />
        <a target="_blank" rel="noreferrer" href="https://t.me/etpestp">
            t.me/etpestp
        </a>
    </div>
);
